<template>
  <div class="absolute top-0 left-0 right-0 bottom-0 w-full h-full flex justify-center items-center">
    <div class="align-middle animate-ping inline-block w-8 h-8 bg-current rounded-full" role="status"></div>
  </div>
</template>
